/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 24/9/2024
 */

import { Button, Container, Dialog, DialogContent, Typography } from '@mui/material'
import React from 'react'
// import backgroundVideo from "../../assets/videos/scuess-1.mp4";
import Styles from "./ContactForm.module.css";

const Success = ({ open, onClose, props }) => {
    return (
        <Dialog
            fullWidth={true}
            open={open}
            onClose={() => onClose()}
            maxWidth={"xs"}
            aria-labelledby="success-dialog-title"
            aria-describedby="success-dialog-description"
        >
            <DialogContent>
                <Container maxWidth="md" >
                    <div className={Styles.sucessMsgContainer}>
                        <Typography my={3} variant="h5" component="div" color="text.primary" textAlign="center" fontWeight="bold">
                            Thank You {props}
                        </Typography>
                        <video autoPlay muted loop id="myVideo" className={Styles.videoCompScuess}>
                            <source src="https://n-ach-file-directory.sgp1.cdn.digitaloceanspaces.com/N_ACH_WEBSITE/N-ach_official_web/videos/scuess-1.mp4" type="video/mp4" />
                        </video>
                        <Typography my={3} component="div" color="text.primary" textAlign="center" fontWeight="400">
                            Your message successfully recieved.
                        </Typography>

                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: "1rem" }}>
                            <Button onClick={() => onClose()} style={{ margin: '0.5rem', width: "10rem" }} fullWidth variant="contained" aria-label="Cancel">Okay</Button>
                        </div>
                    </div>


                </Container>
            </DialogContent>
        </Dialog>
    )
}

export default Success